import './index.scss'
// Add picture of me in the top left corner
import Me from '../../assets/images/jeff.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faLinkedin,
  faGithub,
  faYoutube,
  faDiscord,
} from '@fortawesome/free-brands-svg-icons'
import { faHome, faUser, faEnvelope, faSuitcase } from '@fortawesome/free-solid-svg-icons'
import { Link, NavLink } from 'react-router-dom'
import ReactGA from 'react-ga'

const useGAEventsTracker = (category = "Event Category") => {
  const trackEvent = (action = 'action', label = 'label') => {
    ReactGA.event({ category, action, label })
  };
  return trackEvent
}

const Sidebar = () => {
  const GAEventsTracker = useGAEventsTracker("External Links");

  return (
    <div className="nav-bar">
      <Link className="logo" to="/">
        <img className="sub-logo" src={Me} alt="Jeff Schmidt" />
      </Link>
      <nav>
        <NavLink exact="true" activeclassname="active" to="/">
          <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
        </NavLink>
        <NavLink activeclassname="active" className="about-link" to="/about">
          <FontAwesomeIcon icon={faUser} color="#4d4d4e" />
        </NavLink>
        <NavLink activeclassname="active" className="portfolio-link" to="/projects">
          <FontAwesomeIcon icon={faSuitcase} color="#4d4d4e" />
        </NavLink>
        <NavLink
          activeclassname="active"
          className="contact-link"
          to="/contact"
        >
          <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
        </NavLink>
      </nav>
      <ul>
        <li>
          <a
            href="https://www.linkedin.com/in/jeff-t-schmidt"
            target="_blank"
            rel="noreferrer"
            onClick={e => GAEventsTracker("LinkedIn")}
          >
            <FontAwesomeIcon icon={faLinkedin} color="#4d4d4e" />
          </a>
        </li>
        <li>
          <a
            href="https://github.com/Jeff-T-Schmidt"
            target="_blank"
            rel="noreferrer"
            onClick={e => GAEventsTracker("GitHub")}
          >
            <FontAwesomeIcon icon={faGithub} color="#4d4d4e" />
          </a>
        </li>
        <li>
          <a
            href="https://www.youtube.com/c/WebDevSimplified"
            rel="noreferrer"
            target="_blank"
            onClick={e => GAEventsTracker("YouTube")}
          >
            <FontAwesomeIcon icon={faYoutube} color="#4d4d4e" />
          </a>
        </li>
        <li>
          <a
            href="https://discord.com/users/id/269991981541883907"
            rel="noreferrer"
            target="_blank"
            onClick={e => GAEventsTracker("Discord")}
          >
            <FontAwesomeIcon icon={faDiscord} color="#4d4d4e" />
          </a>
        </li>
      </ul>
    </div>
  )
}

export default Sidebar
